export const DiskI18n = {
  zh: {
    'disk-title': '容量套餐购买',
    'disk-space-1': '容量',
    'disk-space-2': '永久有效',
    'disk-space-3': '已使用',
    'disk-space-4': '未使用',
    'disk-space-5': '查看详情',
    'disk-space-6': '容量组成说明',
    'disk-space-7': '构成方式',
    'disk-space-8': '容量大小',
    'disk-space-9': '有效期',
    'disk-space-10': '扩容',
    'disk-space-11': '普通会员',
    'disk-space-12': '高级会员',
    'disk-space-13': '超级会员',
    'disk-space-14': '专业会员',
    'disk-space-15': '知道了',
    'disk-vip-btn': '开通',
    'disk-list-title': '更多容量套餐',
    'disk-space-btn': '购买',
    'disk-space-price': '企业专享',
    'disk-unit': '年',
    'disk-unit-month': '月',
    'disk-tip':
      '容量套餐购买成功后立即生效，1年后到期。过期后购买的容量会收回，但文件会保留。',
    'disk-tip-more': '了解更多',
    'disk-error': '无效链接~',
    'disk-tip-title': '容量套餐售卖',
    'disk-tip-title-1': '容量套餐是什么?',
    'disk-tip-con-1':
      '答:容量套餐是链上会提供的存储容量扩展服务，当您的云盘存储容量不足时，可以通过购买容量套餐进行容量扩充，存储更多文件。',
    'disk-tip-title-2': '容量套餐购买是否受身份限制？',
    'disk-tip-con-2':
      '答:任何身份( 普通用户 / 高级会员 / 超级会员 / 专业会员 ) 均可购买容量套餐，购买后容量套餐立即生效。',
    'disk-tip-title-3': '容量套餐的有效期如何计算?',
    'disk-tip-con-3':
      '答:当您成功购买容量套餐后，扩展容量立即生效，容量套餐的有效期为一年，有效期按照自然年进行计算。<br />当购买一个容量套餐时，如:	<br />您于2016年2月29日购买一年的容量套餐，则可使用至2017年2月28日23:59:59;	<br />当购买多个容量套餐时，容量进行叠加，如:	<br />您于2016年2月29日购买200G的容量套餐，2016年3月5日再购买300G的容量套餐，在2016年3月5日到2017年2月28日期间。您可使用的容量套餐总和为500G。在2017年3月1日到2017年3月5日期间，您可使用的容量套餐为未到期的300G',
    'disk-tip-title-4': '容量套餐到期后，容量该如何处理?',
    'disk-tip-con-4':
      '答:如您已购买的容量套餐到期，未进行续费，到期后所购买的容量将被收回。<br />当收回容量时您云盘中已存储的文件，小于当前可使用容量，则文件将不受任何影响，仍可正常使用。<br />当收回容量时您云盘中已存储的文件，超出或等于当前可使用容量，超出可使用容量部分的文件不会被删除，但你将无法向云盘中存储文件，即上传、转存、离线下载等功能暂不可用，其它功能不受影响。'
  },
  en: {
    'disk-title': 'Storage purchase',
    'disk-space-1': 'Storage',
    'disk-space-2': 'Permanent',
    'disk-space-3': 'Used',
    'disk-space-4': 'Unused',
    'disk-space-5': 'Details',
    'disk-space-6': 'Storage Composition Description',
    'disk-space-7': 'Composition',
    'disk-space-8': 'Size',
    'disk-space-9': 'Validity Period',
    'disk-space-10': 'Expansion',
    'disk-space-11': 'Essential',
    'disk-space-12': 'Premium',
    'disk-space-13': 'Super',
    'disk-space-14': 'Professional',
    'disk-space-15': 'Ok',
    'disk-vip-btn': 'Opened',
    'disk-list-title': 'More packages',
    'disk-space-btn': 'Buy',
    'disk-space-price': 'Enterprise exclusive',
    'disk-unit': 'year',
    'disk-unit-month': 'month',
    'disk-tip':
      'The capacity package will take effect immediately after successful purchase and expire one year later. purchased after expiration .The capacity is reclaimed, but the files are preserved.',
    'disk-tip-more': 'learn more',
    'disk-error': 'Invalid link~',
    'disk-tip-title': 'Capacity package sales',
    'disk-tip-title-1': 'What is a capacity plan?',
    'disk-tip-con-1':
      'Answer: The capacity package is a storage capacity expansion service provided by ChainPal. When the storage capacity of your network disk is insufficient, you can expand the capacity by purchasing a capacity package to store more files.',
    'disk-tip-title-2': 'Is the capacity plan purchase restricted by identity?',
    'disk-tip-con-2':
      'Answer: Any identity ( ordinary user / premium member / super member / professional member ) can purchase a capacity package, and the capacity package will take effect immediately after purchase.',
    'disk-tip-title-3':
      'How is the validity period of a capacity package calculated?',
    'disk-tip-con-3':
      'Answer: After you successfully purchase the capacity package, the expanded capacity will take effect immediately. The validity period of the capacity package is one year, and the validity period is calculated according to the natural year. <br/> When purchasing a capacity plan, such as: <br/> If you purchased a one - year capacity package on February 29, 2016, you can use it until February 28, 2017 at 23: 59: 59;<br/> When purchasing multiple capacity packages, the capacities are superimposed, such as: <br/> You purchased a 200G capacity package on February 29, 2016, and then purchased a 300G capacity package on March 5, 2016, during the period from March 5, 2016 to February 28, 2017. The total capacity package you can use is 500G.During the period from March 1, 2017 to March 5, 2017, the capacity package you can use is the unexpired 300G',
    'disk-tip-title-4':
      'What should I do with the capacity after the capacity package expires?',
    'disk-tip-con-4':
      'Answer: If the capacity package you have purchased expires and is not renewed, the purchased capacity will be withdrawn after expiration. <br /> When the capacity is recovered, the files stored in your network disk are smaller than the current available capacity, and the files will not be affected in any way and can still be used normally. <br /> When the capacity is recovered, the files stored in your network disk exceed or equal to the current available capacity, and the files exceeding the available capacity will not be deleted, but you will not be able to store files in the network disk, that is, upload, transfer, Functions such as offline download are temporarily unavailable, and other functions will not be affected.'
  }
}
